import { Pipe, PipeTransform } from '@angular/core';
import { Block } from 'app/interfaces/blocks';

@Pipe({
  name: 'filterBlock'
})

export class FilterBlockPipe implements PipeTransform {
  transform(blocks, type) {
    return Object.values(blocks).filter(
      (item: Block) => item.type === type
    );
  }
}
